import React from "react";

import { Input } from "@revvsales/components";
import { RevvForm } from "../../../../commonComponents";

import {
  CustomFieldComponentRules,
  CustomFieldComponentMessages,
} from "../../DynamicField/DynamicFieldComponents/CustomFieldRulesMap";

export default class URLFieldFormMode extends React.Component {
  state = {
    URLTextFieldValues: {
      default: JSON.parse(JSON.stringify(this.props.initialProps.value)),
    },
  };

  _handleOnBlur = (event, value, handleBlur, isValidated) => {
    handleBlur(event);
    // If the field is validated & there is a value then only
    // make an API call and update the redux store
    if ((isValidated && value) || value === "") {
      const { id } = this.props.initialProps;
      this.props._updateDynamicFieldsInDoc(id, value);
      this._checkForUpdateField(value);
    }
  };

  _checkForUpdateField = currentValue => {
    const { id, value: initialValue } = this.props.initialProps;
    if (initialValue !== currentValue) {
      this.props._updateField(id, currentValue);
      this.props.filledStatus(currentValue !== "");
    }
  };

  render() {
    const {
      id,
      label,
      placeholder /* docIsLocked */,
    } = this.props.initialProps;
    return (
      <React.Fragment>
        <RevvForm
          revvFormId={id}
          initialFormValue={this.state.URLTextFieldValues}
          customFieldName="URL"
          customFieldComponentRules={CustomFieldComponentRules}
          validateOnChange
          customFieldComponentMessages={CustomFieldComponentMessages}
          render={formProps => {
            const { handleChange, handleBlur, messages, values } = formProps;
            return (
              <React.Fragment>
                <Input
                  id={id}
                  name="default"
                  className="form-mode-input"
                  // {`form-mode-input ${
                  //   messages.default && messages.default.required !== ""
                  //     ? "danger-border"
                  //     : ""
                  // }`}
                  placeholder={`${placeholder || `Enter ${label}`}`}
                  onChange={event => handleChange(event)}
                  onBlur={event =>
                    this._handleOnBlur(
                      event,
                      values.default,
                      handleBlur,
                      !messages.default,
                    )
                  }
                  value={values.default}
                  disabled={this.props.isLocked}
                  autoFocus
                  data-test="url-field-form-mode"
                />
                {/* <div>
                  {messages.default && (
                    <ErrorMessages messages={messages.default.validateUrl} />
                  )}
                </div> */}

                {/* <JSONPretty id="json-pretty" data={allInAll} /> */}
              </React.Fragment>
            );
          }}
        />
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/DocumentV2/FormView/FormModeComponents/UrlFieldFormMode.js